import styled from 'styled-components';
export const Container = styled.div `
  width: 100%;
  display: flex;
  border-radius: var(--radius-brand);
  border: 1px solid var(--border-secondary);
  background: var(--bg-primary);
  padding: var(--space-400) var(--space-500);
  flex-direction: column;
  align-items: flex-start;
  gap: var(--space-500);
`;
export const Content = styled.div `
  width: 100%;
  flex: 1;
  min-height: 264px;
`;
